import React from 'react';
import Icon from '../Icon';

const Spinner = () => (<Icon icon="spinner-ellipsis" width="10px" />);

export default Spinner;
